(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oorto-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const toolbar = document.querySelector('.oorto-collection .facets-toggle');
    if (toolbar) {
      toolbar.classList.add('oorto-collection__toolbar');
    }

    const filterTrigger = document.querySelector('.oorto-collection .facets-toggle__button');
    if (filterTrigger) {
      filterTrigger.classList.add('oorto-collection__filter-trigger');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oorto-home-hero"] && !Shopify.designMode) return;
  try {
    
  function initOortoHomeHeroCarousels() {
    document.querySelectorAll('.oorto-home-hero__carousel').forEach((carousel) => {
      if (carousel.dataset.carouselInit === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('.oorto-home-hero__slide'));
      const dots = Array.from(carousel.querySelectorAll('.oorto-home-hero__dot'));
      const shouldAutoplay = carousel.dataset.autoplay === 'true';
      const interval = Number(carousel.dataset.autoplayInterval) || 5000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (slides.length <= 1) return;

      carousel.dataset.carouselInit = 'true';

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      let timer = null;

      const goTo = (index) => {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const stopAutoplay = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const startAutoplay = () => {
        if (!shouldAutoplay || reducedMotion.matches) return;

        stopAutoplay();
        timer = setInterval(() => {
          goTo(activeIndex + 1);
        }, interval);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.slideIndex));
          stopAutoplay();
          startAutoplay();
        });
      });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) {
          startAutoplay();
        }
      });

      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      startAutoplay();
    });
  }

  initOortoHomeHeroCarousels();
  document.addEventListener('shopify:section:load', initOortoHomeHeroCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oorto-product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  const STORAGE_KEY = 'oortoRecentlyViewed';
  const MAX_ITEMS = 8;

  class OortoRecentlyViewed extends HTMLElement {
    connectedCallback() {
      const grid = this.querySelector('[data-recently-viewed-grid]');
      const template = this.querySelector('[data-recently-viewed-current]');
      const currentId = this.dataset.currentId;

      if (!grid) return;

      let items = [];
      try {
        items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (error) {
        items = [];
      }

      // Render previously viewed products, excluding the current one.
      const others = items.filter((item) => String(item.id) !== String(currentId));
      if (others.length > 0) {
        grid.innerHTML = others
          .slice(0, MAX_ITEMS)
          .map((item) => item.html)
          .join('');
        this.hidden = false;
      }

      // Save the current product's card to the front of the list.
      if (template && currentId) {
        const html = template.innerHTML.trim();
        if (html) {
          items = items.filter((item) => String(item.id) !== String(currentId));
          items.unshift({ id: String(currentId), html });
          items = items.slice(0, MAX_ITEMS);
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
          } catch (error) {
            /* storage full or unavailable — ignore */
          }
        }
      }
    }
  }

  if (!customElements.get('oorto-recently-viewed')) {
    customElements.define('oorto-recently-viewed', OortoRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oorto-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initOortoTestimonialCarousels() {
    document.querySelectorAll('.oorto-home-testimonials').forEach((section) => {
      if (section.dataset.carouselInit === 'true') return;

      const track = section.querySelector('.oorto-home-testimonials__track');
      const cards = Array.from(section.querySelectorAll('.oorto-home-testimonials__card'));
      const dots = Array.from(section.querySelectorAll('.oorto-home-testimonials__dot'));

      if (!track || cards.length === 0 || dots.length === 0) return;

      section.dataset.carouselInit = 'true';

      const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

      const getCardsPerView = () => (desktopMediaQuery.matches ? 3 : 1);

      const getActiveCardIndex = () => {
        const trackRect = track.getBoundingClientRect();
        const trackCenter = trackRect.left + track.clientWidth / 2;
        let activeIndex = 0;
        let minDistance = Infinity;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const cardCenter = cardRect.left + cardRect.width / 2;
          const distance = Math.abs(trackCenter - cardCenter);

          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      // The active dot is the start card of the current page. Page size follows
      // the breakpoint: 1 card on mobile (every dot), 3 on desktop (page-start dots).
      const setActiveDots = (activeCardIndex) => {
        const cardsPerView = getCardsPerView();
        const activeDotIndex = Math.floor(activeCardIndex / cardsPerView) * cardsPerView;

        dots.forEach((dot) => {
          const isActive = Number(dot.dataset.testimonialIndex) === activeDotIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const scrollToCard = (cardIndex) => {
        const card = cards[cardIndex];

        if (!card) return;

        // Desktop pages snap to the start of a 3-card group.
        if (getCardsPerView() > 1) {
          card.scrollIntoView({
            behavior: 'smooth',
            inline: 'start',
            block: 'nearest',
          });
          return;
        }

        // Mobile: centre the card inside the track so the last slide can land
        // dead-centre (scrollIntoView inline:center often can't when space runs out).
        const trackRect = track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const nextLeft =
          track.scrollLeft + (cardRect.left - trackRect.left) - (track.clientWidth - cardRect.width) / 2;

        track.scrollTo({
          left: Math.max(0, nextLeft),
          behavior: 'smooth',
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          scrollToCard(Number(dot.dataset.testimonialIndex));
        });
      });

      track.addEventListener(
        'scroll',
        () => {
          setActiveDots(getActiveCardIndex());
        },
        { passive: true }
      );

      desktopMediaQuery.addEventListener('change', () => {
        setActiveDots(getActiveCardIndex());
      });

      // Sync the active dot to the current scroll position / breakpoint on load.
      setActiveDots(getActiveCardIndex());
    });
  }

  initOortoTestimonialCarousels();
  document.addEventListener('shopify:section:load', initOortoTestimonialCarousels);

  } catch(e) { console.error(e); }
})();
})();
